









































































import Controller from './controller/Controller';
//import ConfiguratorDimensions from './configuratorDimensions.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Provide, Prop, Watch } from 'vue-property-decorator';
import { ConfiguratorService } from '../services/sketchfab/index';
import { setTimeout } from 'timers';
import { Store } from '@/store';
import { ComponentContainer } from '@/services/container';
import { ServiceIdentifiers } from '@/services';
import { Types, ConfigurationServiceInitiated } from '@/models/events';
import { ProductDefinition } from '@/models/configurator';
import * as _ from 'lodash';
import SketchfabFrame from '@/components/skecthfabFrame/SketchfabFrame.vue';
import { config } from 'bluebird';
import $ from 'jquery';

@Component({
  components: {
    sketchfab: SketchfabFrame,
    controller: Controller,
    //dimensions: ConfiguratorDimensions,
  },
})
export default class Configurator extends Vue {
  public initiated: boolean = false;

  public productDefinition: ProductDefinition = null;
  public isMobile: boolean = false;

  public isMobileMenuOpen : boolean = false;


  @Prop() familyId: string;
  @Prop() prodcutId: string;
  @Prop() selectionHash: string;
  @Prop() lang: string;
  @Prop() vmode: string;

  public sketchfabOptions = {
    sketchfabModelId: null,
    textureBaseUrl: null,
  };

  windowHeight: number = 0;

  @Provide() private _container: ComponentContainer = null;

  selectedFamilyID: string = null;

  beforeCreate() {
    this._container = new ComponentContainer();
  }

  created() {
    this.isMobile = window.innerWidth < 1000;
    if (this.vmode)
    {
      this.$root.$data.viewmode = this.vmode;
    }
    else
    {
      this.$root.$data.viewmode = 'a3';
    }
    if (this.lang)
    {
      this.$root.$data.locale = this.lang;
    }
    if (this.familyId) {
      Store.state.family = Store.getFamilyById(this.familyId);
      this.selectedFamilyID = this.familyId;
    } else {
      this.selectedFamilyID = 'banzai';
    }
    if (this.prodcutId) {
      Store.state.product = Store.getProductById(this.prodcutId);
    }
    if (this.selectionHash) {
      Store.state.selection = this.getSelectOptionsFromBase64String(this.selectionHash);
    }

    this.sketchfabOptions.textureBaseUrl =
      Store.state.configuratorConfig.textureBaseUrl;
    this.sketchfabOptions.sketchfabModelId = Store.getFamilyById(
      this.selectedFamilyID,
    ).sketchfabModelId;

    this.$root.$on(
      Types.ConfigurationServiceInitiatedEvent,
      (event: ConfigurationServiceInitiated) => {
        this._container.register(ServiceIdentifiers.ConfiguratorService, () => Store.getConfiguratorService(event.sketchfabModelId));
        this.initiated = true;
      });
  }

  private getSelectOptionsFromBase64String(selectedOptionsBase64: string) {
    if (!selectedOptionsBase64) {
      return null;
    }
    const json = this.base64Decode(selectedOptionsBase64);
    const o = JSON.parse(json);
    if (o == null) {
      return null;
    }

    return o;
  }

  base64Decode(base64: string): string {
    return decodeURIComponent(encodeURIComponent(window.atob(base64)));
  }

  clickedElement(e: any) {
    $('.navbar-toggler').click();
  }

  /* tslint:disable */
  mounted() {
    let that = this;
    this.$nextTick(function() {
      window.addEventListener('resize', function(e) {
        that.windowHeight = window.innerWidth;
        Store.state.isMobile = that.isMobile = that.windowHeight < 1000;

      });
      $(document).on('click', '.js--close', e => this.clickedElement(e));
      $(document).on('hidden.bs.collapse','#mobileNavbarToggler',function() {
        that.isMobileMenuOpen = false;
      }).on('show.bs.collapse','#mobileNavbarToggler', function() {
        that.isMobileMenuOpen = true;
      })
    });
  }
  /* tslint:enable */
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Configurator.vue